<div [class.active]="isActive" [class.visited]="isVisited" class="step-box" [ngClass]="design + '-design'">
  <div [ngSwitch]="isVisited" class="step-number">
    <app-icon *ngSwitchCase="true" [svgIcon]="IconsEnum.check_circle"></app-icon>
    <ng-container *ngSwitchCase="false">{{ stepNumber }}</ng-container>
  </div>

  <div class="step-desc" [innerHTML]="isVisited ? descVisited : descActive"></div>

  <ng-container [ngSwitch]="isVisited">
      <app-ui-button *ngSwitchCase="true" [variant]="design === 'activation' ? 'secondary' : 'floating'" [size]="'small'"
                     [label]="stepTexts?.visited_btn" (clicked)="visitedClick.emit()">
      </app-ui-button>
      <app-ui-button *ngSwitchCase="false" [variant]="'primary'" [size]="'small'" (clicked)="activeClick.emit()" [isDisabled]="!isActive"
                     [label]="stepTexts?.active_btn">
      </app-ui-button>
  </ng-container>
</div>
